// REGISTRATION-PAUSE (FNP-1222) — TEMPORARY. Delete this file when the pause is
// removed; see src/config/registration.ts for the removal steps.
import {
    Center,
    Group,
    Stack,
    Text,
    Title,
} from '@mantine/core';

import {Link} from 'react-router-dom';

import {registrationClosedContent} from '../../../../config/registration';

export const RegistrationClosedPage = () => {
    return (
        <Center p={'xl'}>
            <Stack align={'center'} maw={480}>
                <Title order={2} ta={'center'}>
                    {registrationClosedContent.title}
                </Title>

                <Text ta={'center'}>
                    {registrationClosedContent.message}
                </Text>

                <Group>
                    <Text>{registrationClosedContent.signInPrompt}</Text>
                    <Link to={'/sign-in'}>{registrationClosedContent.signInLabel}</Link>
                </Group>
            </Stack>
        </Center>
    );
};
